var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppCheckbox',{attrs:{"id":_vm.prefix_id,"label":_vm.label,"inputValue":_vm.inputValue},on:{"change":function($event){return _vm.change($event)}}}),(!_vm.isLast)?_c('v-divider',{staticClass:"my-1"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }